<div mat-dialog-title class="dialog-info" closeOnEscape>
    <label class="dialogTitle">
        {{'ADD_COLLABORATOR' | translate}}
    </label>
    <button type="button" class="btn-close btn-close-white shadow-none dialogCross" [mat-dialog-close]></button>
</div>
<mat-dialog-content class="content-container">
    <div [formGroup]="propertiesCollaboratorForm">
        @if(!dialogData.isCalledFromPreferences){
        <div class="row mt-3 ms-0 col-sm-12 row-height">
            <div class="col-sm-2 p-0">
                <label>{{'AVAILABLE' | translate}}</label>
            </div>
            <div class="col-sm-8 ps-0">
                <mat-form-field appearance="outline" class="col-sm-12">
                    <mat-select formControlName="availableCollaborator"
                        (selectionChange)="onAvailableReviewerChange($event)">
                        @for (reviewer of availableReviewers; track $index) {
                        <mat-option class="optionHeight" [value]="reviewer.email">{{reviewer.name}}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-sm-2"></div>
        </div>
        <hr>
        }
        <div class="row col-sm-12 m-0 row-height">
            <div class="col-sm-2 p-0">
                <label>{{'ROLE' | translate}}</label>
            </div>
            <div class="col-sm-8 ps-0">
                <mat-form-field appearance="outline" class="col-sm-12">
                    <mat-select formControlName="role" (selectionChange)="onRoleChange($event)">
                        @for (role of collaboratorRoles; track $index) {
                        <mat-option class="optionHeight" [value]="role.id">
                            {{role.description}}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="row col-sm-12 m-0 row-height">
            <div class="col-sm-2 p-0">
                <label>{{'REVIEW_CANCEL_DIALOG_NAME'| translate}}</label>
            </div>
            <div class="col-sm-8 ps-0">
                <mat-form-field appearance="outline" class="col-sm-12">
                    <input matInput formControlName="name">
                </mat-form-field>
            </div>
        </div>
        <div class="row col-sm-12 m-0 row-height">
            <div class="col-sm-2 p-0">
                <label>{{'REVIEW_CANCEL_DIALOG_EMAIL'| translate}}</label>
            </div>
            <div class="col-sm-8 ps-0">
                <mat-form-field appearance="outline" class="col-sm-12">
                    <input matInput formControlName="email">
                </mat-form-field>
            </div>
            <div class="col-sm-2">
                <button mat-raised-button color="primary" [disabled]="!enableVerify()"
                    (click)="onVerifyClick()">{{'VERIFY_BTN_LABEL'| translate}}</button>
            </div>
        </div>
        <div class="row col-sm-12 m-0 row-height">
            <div class="col-sm-2 p-0">
                <label>{{'ACCESS'| translate}}</label>
            </div>
            <div class="col-sm-8 ps-0">
                <mat-slide-toggle color="primary" formControlName="canEdit">
                    {{canEdit.value ? ('EDIT' | translate) : ('VIEW' | translate)}}
                </mat-slide-toggle>
            </div>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    @if(!isModifyMode){
    <button mat-raised-button color="primary" (click)="onAdd()" [disabled]="!enableAdd()">{{'ADD' |
        translate}}</button>
    }
    <button mat-button mat-mdc-raised-button color="warn" mat-dialog-close>{{'CANCEL_BTN_LABEL' | translate}}</button>
</mat-dialog-actions>